import React from 'react';
import { WifiOff, RefreshCw, Cloud, CloudOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useOffline } from '@/hooks/useOffline';

export function OfflineIndicator() {
  const { online, syncing, pendingCount, syncNow } = useOffline();

  if (online && pendingCount === 0) {
    return null;
  }

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 px-4 py-2 text-sm font-medium flex items-center justify-between ${
      online ? 'bg-amber-500 text-white' : 'bg-red-500 text-white'
    }`}>
      <div className="flex items-center gap-2">
        {online ? (
          <>
            <Cloud className="h-4 w-4" />
            <span>{pendingCount} modification(s) en attente de synchronisation</span>
          </>
        ) : (
          <>
            <WifiOff className="h-4 w-4" />
            <span>Mode hors ligne - Les modifications seront synchronisées à la reconnexion</span>
          </>
        )}
      </div>
      
      {online && pendingCount > 0 && (
        <Button
          onClick={syncNow}
          disabled={syncing}
          size="sm"
          variant="secondary"
          className="h-7 text-xs"
        >
          {syncing ? (
            <>
              <RefreshCw className="h-3 w-3 mr-1 animate-spin" />
              Synchronisation...
            </>
          ) : (
            <>
              <RefreshCw className="h-3 w-3 mr-1" />
              Synchroniser
            </>
          )}
        </Button>
      )}
    </div>
  );
}

// Compact version for header
export function OfflineStatusBadge() {
  const { online, pendingCount } = useOffline();

  if (online && pendingCount === 0) {
    return (
      <div className="flex items-center gap-1 text-xs text-green-600">
        <Cloud className="h-3 w-3" />
        <span className="hidden sm:inline">En ligne</span>
      </div>
    );
  }

  if (!online) {
    return (
      <div className="flex items-center gap-1 text-xs text-red-600">
        <CloudOff className="h-3 w-3" />
        <span className="hidden sm:inline">Hors ligne</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1 text-xs text-amber-600">
      <RefreshCw className="h-3 w-3" />
      <span className="hidden sm:inline">{pendingCount} en attente</span>
    </div>
  );
}

export default OfflineIndicator;
